import { useCallback, useMemo } from 'react';

import { IUseQueryProps } from 'store/queries/types';
import { getQueryParams } from 'store/utils/getQueryParams';
import { useAppSelector } from 'store/useAppSelector';

import {
  IFetchTeamAccountJWTParams,
  selectTeamAccountJWT,
  selectTeamAccountJWTLoading,
  selectTeamAccountJWTState,
  useFetchTeamAccountJWTQuery,
  useLazyFetchTeamAccountJWTQuery,
} from '../fetchTeamAccountJWT';

export interface UseTeamAccountJWTQueryProps
  extends IUseQueryProps,
    IFetchTeamAccountJWTParams {}

export const useTeamAccountJWTQuery = ({
  group,
  skipFetching,
}: UseTeamAccountJWTQueryProps) => {
  const params = useMemo(
    (): IFetchTeamAccountJWTParams => ({ group }),
    [group],
  );

  useFetchTeamAccountJWTQuery(getQueryParams({ params, skipFetching }));

  const [fetchLazy] = useLazyFetchTeamAccountJWTQuery();

  const handleFetchTeamAccountJWT = useCallback(
    () => fetchLazy(params),
    [fetchLazy, params],
  );

  const teamAccountJWT = useAppSelector(state =>
    selectTeamAccountJWT(state, params),
  );

  const loading = useAppSelector(state =>
    selectTeamAccountJWTLoading(state, params),
  );

  const state = useAppSelector(storeState =>
    selectTeamAccountJWTState(storeState, params),
  );

  return {
    handleFetchTeamAccountJWT,
    loading,
    params,
    state,
    teamAccountJWT,
  };
};
